/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, balance: NonNullable<unknown> }} Admin_Users_Manage_Credits_ForInputs */

const en_admin_users_manage_credits_for = /** @type {(inputs: Admin_Users_Manage_Credits_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, current balance: ${i?.balance}`)
};

/**
* | output |
* | --- |
* | "{name}, current balance: {balance}" |
*
* @param {Admin_Users_Manage_Credits_ForInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_manage_credits_for = /** @type {((inputs: Admin_Users_Manage_Credits_ForInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Manage_Credits_ForInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_manage_credits_for(inputs)
});
export { admin_users_manage_credits_for as "admin.users.manage_credits_for" }